export default import.meta.ROLLDOWN_FILE_URL_1auHEeHI6St45$3SiNGoNw